
// @ts-nocheck
import { AsmtMixin } from '@mixins'
import { ItemValidationErrors as IVE } from '@helpers/itemValidation'

const ErrorMessages = {
  [IVE.ChoiceNone]: 'Item has no choices. A minimum of 2 choices is allowed.',
  [IVE.ChoiceMin]: 'A minimum of 2 choices is allowed.',
  [IVE.ChoiceMax]: 'A maximum of 9 choices is allowed.',
  [IVE.CorrectNone]: 'Item requires correct answer.',
  [IVE.Rubric1PTExcludeZeroNotAllowed]:
    'Rubrics cannot have max points of 1 and exclude 0 enabled. %revise-item-help% and either increase the max points or remove the exclude zero option.',
  [IVE.RubricWeightZeroNotAllowed]: 'Weight cannot be zero.',
  [IVE.RubricWeightMismatch]:
    'Item weight must match rubric value. %revise-item-help% to make the weight and the rubric value the same.',
  [IVE.PartialScoringWeightZeroNotAllowed]: 'Item weight must be 1 or higher with Partial Scoring enabled.',
  [IVE.WeightMin]: '%item-type% must have a weight of 1 or higher.',
}

export default {
  name: 'IbxAmstItemValidation',

  mixins: [AsmtMixin],

  props: {
    itemRevId: { type: Number, default: null },
    itemTypeLabel: { type: String, default: '' },
  },

  data: () => ({
    itemReviseHelp: 'https://support.illuminateed.com/hc/en-us/articles/30104521908379-Revise-Items-in-the-Item-Bank',
  }),

  computed: {
    validationErrorMessage() {
      let message = ''

      if (this.itemRevId) {
        const errors = this.asmtGetItemValidationErrors(this.itemRevId)

        if (errors.length) {
          const more = errors.length > 1 ? `+ ${errors.length - 1} more.` : ''
          message = `${ErrorMessages[errors[0]]} ${more}`

          // string replacements
          const replacements = {
            '%revise-item-help%': `<a class="ibx-asmt-item-validation__help-link" href="${this.itemReviseHelp}" target="_blank">Edit the item</a>`,
            '%item-type%': this.itemTypeLabel,
          }

          for (const k in replacements) {
            message = message.replaceAll(k, replacements[k])
          }
        }
      }

      return message
    },
  },
}
